import React from 'react';

import { X } from 'lucide-react';

import { formatDegradedMessage } from './vedaDegradedMessages';



export default function VedaEngineDataGapsBanner({ gaps, meta, extraDegradedReasons, onDismiss }) {

  const reasons = [

    ...(meta?.degradedReasons || gaps?.degradedReasons || []),

    ...(extraDegradedReasons || []),

  ];

  const uniqueReasons = [...new Set(reasons.filter(Boolean))];

  const degraded = Boolean(meta?.degraded || gaps?.degraded || uniqueReasons.length > 0);



  if (!degraded) return null;



  const message = formatDegradedMessage(uniqueReasons);



  return (

    <div

      className="mx-2 md:mx-4 lg:mx-6 mt-2 mb-0 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"

      role="status"

    >

      <div className="flex-1 min-w-0">

        <p className="font-medium">Partial or inconsistent model data</p>

        <p className="mt-1 text-amber-800">{message}</p>

      </div>

      <button

        type="button"

        onClick={onDismiss}

        className="flex-shrink-0 p-1 rounded hover:bg-amber-100 transition-colors"

        aria-label="Dismiss"

      >

        <X className="h-4 w-4" />

      </button>

    </div>

  );

}



export { formatDegradedMessage } from './vedaDegradedMessages';

